import classNames from 'classnames'
import Icon from '@components/Icon'
import { getClusterIcon } from 'map/helpers'
import styles from './styles.module.scss'

const Cluster = ({ theme, pointCount, onClick, hovered, faded, style }) => (
    <div
        className={classNames(styles.cluster, {
            [styles.hovered]: hovered,
        })}
        onClick={onClick}
        style={style}>
        <Icon className={styles.icon} type={getClusterIcon({ theme, faded })} />
        <span className={styles.text}>{pointCount}</span>
    </div>
)

export default Cluster
